import React from 'react';
// src/components/Skeleton.jsx
// IMPROVEMENT 2: Skeleton loading screens
// Pulsing grey placeholder cards that match the shape of real content
// Zero dependencies — pure CSS animation

export function SkeletonBlock({ width = '100%', height = 16, radius = 6, style = {} }) {
  return (
    <div style={{
      width, height,
      borderRadius: radius,
      background: 'linear-gradient(90deg, #1C1C1C 25%, #2A2A2A 50%, #1C1C1C 75%)',
      backgroundSize: '200% 100%',
      animation: 'skeletonShimmer 1.4s infinite',
      flexShrink: 0,
      ...style,
    }}/>
  );
}

// A full coin row skeleton — matches exact shape of CoinRow
export function SkeletonCoinRow() {
  return (
    <div style={{ display:'flex', alignItems:'center', padding:'11px 0', gap:10, borderBottom:'1px solid #1E1E1E' }}>
      <SkeletonBlock width={34} height={34} radius={17} style={{ flexShrink:0 }}/>
      <div style={{ flex:1, display:'flex', flexDirection:'column', gap:6 }}>
        <SkeletonBlock width="40%" height={13}/>
        <SkeletonBlock width="60%" height={10}/>
      </div>
      <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:6 }}>
        <SkeletonBlock width={70} height={13}/>
        <SkeletonBlock width={50} height={10}/>
      </div>
    </div>
  );
}

// A full card skeleton — matches shape of news/post/order cards
export function SkeletonCard({ lines = 3 }) {
  return (
    <div style={{ background:'#1C1C1C', border:'1px solid #252525', borderRadius:12, padding:16, marginBottom:12 }}>
      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12 }}>
        <SkeletonBlock width="30%" height={11}/>
        <SkeletonBlock width="20%" height={11}/>
      </div>
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock key={i} width={i === lines - 1 ? '60%' : '100%'} height={13} style={{ marginBottom: i < lines - 1 ? 8 : 0 }}/>
      ))}
    </div>
  );
}

// A trader card skeleton — for CopyTradingPage
export function SkeletonTraderCard() {
  return (
    <div style={{ background:'#1C1C1C', border:'1px solid #252525', borderRadius:12, padding:16, marginBottom:12 }}>
      <div style={{ display:'flex', gap:12, alignItems:'center', marginBottom:12 }}>
        <SkeletonBlock width={44} height={44} radius={22} style={{ flexShrink:0 }}/>
        <div style={{ flex:1, display:'flex', flexDirection:'column', gap:6 }}>
          <SkeletonBlock width="50%" height={14}/>
          <SkeletonBlock width="70%" height={11}/>
        </div>
        <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:6 }}>
          <SkeletonBlock width={60} height={16}/>
          <SkeletonBlock width={45} height={11}/>
        </div>
      </div>
      <SkeletonBlock width="100%" height={36} radius={8}/>
    </div>
  );
}

// Inject keyframe once — used by all skeleton variants
export function SkeletonStyles() {
  return (
    <style>{`
      @keyframes skeletonShimmer {
        0%   { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `}</style>
  );
}

// Position card skeleton — matches PositionsPage card shape
export function SkeletonPositionCard() {
  return (
    <div style={{ background:'#111', borderRadius:14, padding:16, marginBottom:12, border:'1px solid #1E1E1E' }}>
      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12 }}>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <SkeletonBlock width={36} height={36} radius={18}/>
          <div><SkeletonBlock width={60} height={14} style={{ marginBottom:4 }}/><SkeletonBlock width={80} height={10}/></div>
        </div>
        <div style={{ textAlign:'right' }}><SkeletonBlock width={90} height={20} style={{ marginBottom:4 }}/><SkeletonBlock width={50} height={10}/></div>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
        <SkeletonBlock height={50} radius={8}/><SkeletonBlock height={50} radius={8}/>
        <SkeletonBlock height={50} radius={8}/><SkeletonBlock height={50} radius={8}/>
      </div>
    </div>
  );
}

// Order row skeleton — matches OrdersPage row shape
export function SkeletonOrderRow() {
  return (
    <div style={{ background:'#111', borderRadius:12, padding:14, marginBottom:8, border:'1px solid #1E1E1E' }}>
      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
        <SkeletonBlock width={100} height={14}/><SkeletonBlock width={60} height={14}/>
      </div>
      <SkeletonBlock width="70%" height={12} style={{ marginBottom:6 }}/>
      <SkeletonBlock width="40%" height={10}/>
    </div>
  );
}

export default React.memo(SkeletonBlock);
